import { useMutation } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

export interface LeadUpdateItem {
  lead_uuid: string
  fieldName: string
  newValue: any
}

const batchUpdateLeads = async (updates: LeadUpdateItem[]): Promise<any> => {
  const url = `${baseUrl}/aws/leads/batch-update`
  try {
    const response = await axios.post(url, { updates })
    if (response.status !== 200) throw new Error('Network response was not ok')
    return response.data
  } catch (error) {
    console.error('Failed to batch update leads:', error)
    throw error
  }
}

export const useBatchUpdateLeads = () => {
  return useMutation({
    mutationFn: batchUpdateLeads,
    onError: error => {
      console.error('[useBatchUpdateLeads] Error batch updating leads:', error)
    },
  })
}
